import { render, staticRenderFns } from "./PagedTabsTableView.vue?vue&type=template&id=3ae94dad&"
import script from "./PagedTabsTableView.vue?vue&type=script&lang=ts&"
export * from "./PagedTabsTableView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports